
<template>
    <ListDialog ref="CommodityAnalyseDialog" :title="$parent.formatTitle('商品分析表')" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	      <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="CommodityAnalyseReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【商品分析表】のデータを選択でき、初期値は×で消してから変更が可能です。" />
	      <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
        <AtcCategory title="商品区分" :categoryGroup="categoryGroupCommodity" :value.sync="commodityCategory" tooltip="ここで商品区分を選択をすると、選択した区分だけのデータを出力する事ができます。選択しない場合はすべての区分のデータが出力できます。" />
        <Calendar title="限月(From)" :editor="editor" :value.sync="closingDateFrom" :deletable="false" :required="true" :month="true"  :autoEntry="true" :dateFlag.sync="closingDateFromFlag" tooltip="データを帳票に出力する期間の開始月を指定します。ここで指定した月以前のデータは出力対象外となります。" />
	      <Calendar title="限月(To)" :editor="editor" :value.sync="closingDateTo" :deletable="false" :required="true" :month="true" :autoEntry="true" :dateFlag.sync="closingDateToFlag" tooltip="データを帳票に出力をする期間の終了月を指定します。ここで指定した月以降のデータは出力対象外となります。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>        
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>               
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptCommodityAnalyse extends Vue {

  // 商品分析表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public closingDateFrom: Date = null;
  public closingDateTo: Date = null;
  public segment: Common.Segment = null;
  public commodityCategory: Common.Category = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public onExcelExport :boolean = false;
  public closingDateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public closingDateToFlag : Common.dateFlags = Common.dateFlags.default;

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.CommodityAnalyseReportTemplateQuery = new Common.CommodityAnalyseReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    var today = new Date().getCalendarDate();
    this.closingDateFrom = today;
    this.closingDateTo = today;
    (this.$refs.CommodityAnalyseDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.CommodityAnalyseReportQuery = new Common.CommodityAnalyseReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.closingDateFrom = new Date(this.closingDateFrom.getFullYear(),this.closingDateFrom.getMonth() +1,0).getCalendarDate();
    query.closingDateTo = new Date(this.closingDateTo.getFullYear(),this.closingDateTo.getMonth() +1,0).getCalendarDate();
    query.segment = this.segment;
    query.commodityCategory = this.commodityCategory;
    query.onExcelExport = this.onExcelExport;
    this.$api.download(query);
  }
}
</script>
